export const itemComponentMap = {
  p: (children: React.ReactNode) => <p className="mt-2">{children}</p>,
  h2: (chunks: React.ReactNode) => (
    <h2 className="font-bold mt-16 mb-4">{chunks}</h2>
  ),
  h3: (chunks: React.ReactNode) => (
    <h3 className="font-bold mt-16 mb-4">{chunks}</h3>
  ),
  h4: (chunks: React.ReactNode) => (
    <h4 className="font-bold mt-16 mb-4">{chunks}</h4>
  ),
  strong: (children: React.ReactNode) => (
    <strong className="font-bold">{children}</strong>
  ),
  italic: (children: React.ReactNode) => <em className="italic">{children}</em>,
  br: () => <br />,
  ul: (children: React.ReactNode) => (
    <ul className="list-disc ml-8 mb-3">{children}</ul>
  ),
  ol: (children: React.ReactNode) => (
    <ol className="list-decimal pl-5 mb-3">{children}</ol>
  ),
  olloweralpha: (children: React.ReactNode) => (
    <ol className="ml-8 mb-2 lower-alpha-parenthesis">{children}</ol>
  ),
  olroman: (children: React.ReactNode) => (
    <ol className="ml-8 mb-2 list-[upper-roman]">{children}</ol>
  ),
  ollowerroman: (children: React.ReactNode) => (
    <ol className="ml-8 mb-2 list-[lower-roman]">{children}</ol>
  ),
  li: (children: React.ReactNode) => <li>{children}</li>,
  table: (children: React.ReactNode) => (
    <div className="my-4 max-md:overflow-x-scroll">
      <table className="border">{children}</table>
    </div>
  ),
  thead: (children: React.ReactNode) => <thead>{children}</thead>,
  tbody: (children: React.ReactNode) => <tbody>{children}</tbody>,
  tr: (children: React.ReactNode) => <tr className="border-b">{children}</tr>,
  th: (children: React.ReactNode) => (
    <th className="py-2 px-4 font-bold text-left border">{children}</th>
  ),
  td: (children: React.ReactNode) => (
    <td className="py-2 px-4 border">{children}</td>
  ),
  "mail-to-seller": (children: React.ReactNode) => (
    <a className="underline" href="mailto:seller@ipriceit.it">
      {children}
    </a>
  ),
  "mail-to-customer-service": () => (
    <a href="mailto:customerservice@ipriceit.it" className="underline">
      customerservice@ipriceit.it
    </a>
  ),
  "phone-link": () => (
    <a href="tel:+393273143248" className="underline">
      +39 3273143248
    </a>
  ),
  "faq-link-consumer": (children: React.ReactNode) => (
    <a href="/help" className="underline" target="_blank">
      {children}
    </a>
  ),
  "garante-link": (children: React.ReactNode) => (
    <a
      className="underline"
      target="_blank"
      href="https://www.garanteprivacy.it"
    >
      {children}
    </a>
  ),
  "data-protection-link": (children: React.ReactNode) => (
    <a
      className="underline"
      target="_blank"
      href="https://ec.europa.eu/justice/article-29/structure/data-protection-authorities/index_en.htm"
    >
      {children}
    </a>
  ),
};
